if (!customElements.get('mt-trust-marquee')) {
  customElements.define('mt-trust-marquee', class extends HTMLElement {
    connectedCallback() {
      const group = this.querySelector('.mt-trust-marquee__group');
      if (!group || this.resizeObserver) return;
      const size = () => {
        if (!this.isConnected) return;
        this.style.setProperty('--mt-trust-duration', Math.max(20, group.getBoundingClientRect().width / 36) + 's');
      };
      size();
      document.fonts.ready.then(size);
      this.resizeObserver = new ResizeObserver(size);
      this.resizeObserver.observe(group);
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
    }
  });
}
